import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { Parcel } from 'app/core/app.model';
import { Branding } from 'app/core/auth/user.model';
import { ReportTitle } from 'app/core/report/report.model';
import { BrandingComponent } from '../branding/branding.component';
import { GoogleImageComponent } from '../google/google-image.component';
import { GoogleStreetViewImageComponent } from '../google/google-street-view-image.component';


@Component({
    selector: 'cover-parcel-image',
    imports: [
        GoogleStreetViewImageComponent,
    ],
    styles: [
        `
        @media screen, print {
            .custom-image {
                width: 100%;
            }
        }
        `,
    ],
    template: `
        @if (image()) {
            <img class="custom-image" [src]="image()">
        }
        @else {
            <google-street-view-image
                [width]="370"
                [height]="200"
                [clickToShow]="false"
                [address]="parcel()"
                [center]="parcel().geocenter">
            </google-street-view-image>
        }
    `,
})
export class CoverParcelImageComponent {

    parcel = input.required<Parcel>();

    image = input<string | null>(null);
}


@Component({
    selector: 'cover-default',
    imports: [
        DatePipe,
        CoverParcelImageComponent,
        GoogleImageComponent,
        BrandingComponent,
    ],
    styles: [
        `
        @media screen, print {
            .address {
                vertical-align: top;
            }
            .address p {
                margin: 3px 0;
            }
            table {
                width: 100%;
            }
            .branding {
                border-bottom: 3px dotted #DDD;
                padding-bottom: 20px;
                margin-bottom: 20px;
            }
            .tiles {
                padding-bottom: 40px;
                border-bottom: 3px dotted #DDD;
            }
            td {
                width: 50%;
            }
            .cover-container {
                padding: 25px 19px;
            }
            .trademark-statement {
                position: absolute;
                bottom: 0px;
                right: 0px;
                padding-right: 25px;
                color: gray;
                font-size: 10px;
                max-width: 550px;
                text-align: right;
            }
        }
        `,
    ],
    template: `
        <div class="cover-container">
            <div class="branding">
                <branding-component type="reportType" [branding]="branding()"></branding-component>
            </div>
            <div class="tiles">
                <table>
                    <tr>
                        <td class="address">
                            <h3 class="report-title">Property Report</h3>
                            <p>Created on {{ createdAt() | date }}</p>
                            <p>{{ title().addressLine1 }}</p>
                            @if (title().addressLine2) {
                                <p>{{ title().addressLine2 }}</p>
                            }
                            <p>{{ title().municipality }}</p>
                            <p>{{ title().postalCode }}</p>
                            <p>{{ parcel().countryLong }}</p>
                            <p>PID {{ title().pid }}</p>
                        </td>
                        <td>
                            @if (showGoogleImages()) {
                                <google-image
                                    [width]="370"
                                    [height]="200"
                                    [center]="parcel().geocenter"
                                    [polygon]="parcel().geometry">
                                </google-image>
                            }
                            @else {
                                <cover-parcel-image [parcel]="parcel()" [image]="image()"></cover-parcel-image>
                            }
                        </td>
                    </tr>
                    @if (showGoogleImages()) {
                        <tr>
                            <td>
                                <google-image
                                    [width]="370"
                                    [height]="200"
                                    maptype="satellite"
                                    [center]="parcel().geocenter"
                                    [polygon]="parcel().geometry">
                                </google-image>
                            </td>
                            <td>
                                <cover-parcel-image [parcel]="parcel()" [image]="image()"></cover-parcel-image>
                            </td>
                        </tr>
                    }
                </table>
            </div>
            @if (creaTrademarkStatement()) {
                <div class="trademark-statement">
                    <p>{{ creaTrademarkStatement() }}</p>
                </div>
            }
        </div>
    `,
})
export class CoverDefaultComponent {

    title = input.required<ReportTitle>();

    parcel = input.required<Parcel>();

    createdAt = input<string>();

    branding = input.required<Branding | null>();

    creaTrademarkStatement = input<string | null>(null);

    image = input<string | null>(null);

    showGoogleImages = input(true);
}
